import { type FC } from 'react';

import { type ScoreSettingsConfig } from '@soomo/lib/components/pageElements/GoReact/types';

interface Props {
	scoreSettings: ScoreSettingsConfig;
}

const ScoreSettingsPreview: FC<Props> = (props) => {
	const { scoreSettings } = props;

	const recordingMaking = scoreSettings?.completionOptions?.recordingMaking;
	const selfReview = scoreSettings?.completionOptions?.selfReview;
	const nonSelfReview = scoreSettings?.completionOptions?.nonSelfReview;
	const providedReview = scoreSettings?.completionOptions?.providedReview;

	return (
		<div>
			{!scoreSettings?.scoreOptions && <span className="noSettingText">No settings selected</span>}

			{scoreSettings?.scoreOptions === 'noPoints' && (
				<span>Students will not receive points for this assignment.</span>
			)}

			{scoreSettings?.scoreOptions === 'instructorGrade' && (
				<span>The instructor will score the assignment.</span>
			)}

			{scoreSettings?.scoreOptions === 'pointsForCompletion' && (
				<>
					<span>Students will receive points for:</span>

					<ul>
						{/* Recording Making preview */}
						{recordingMaking?.required && <li>posting a recording</li>}

						{/* Self Review preview */}
						{selfReview?.required && <li>reviewing their own recording</li>}
						{!!selfReview?.commentsNumber && (
							<li>leaving at least {selfReview?.commentsNumber} comment(s)</li>
						)}
						{!!selfReview?.markersNumber && (
							<li>leaving at least {selfReview?.markersNumber} marker(s)</li>
						)}
						{selfReview?.rubricSubmission && <li>submitting a rubric</li>}

						{/* Non Self preview */}
						{nonSelfReview?.required && <li>reviewing someone else's video</li>}
						{!!nonSelfReview?.reviewsNumber && (
							<li>reviewing at least {nonSelfReview?.reviewsNumber} videos</li>
						)}
						{!!nonSelfReview?.commentsNumber && (
							<li>
								leaving at least {nonSelfReview?.commentsNumber} comment(s) per reviewed video
							</li>
						)}
						{!!nonSelfReview?.markersNumber && (
							<li>leaving at least {nonSelfReview?.markersNumber} marker(s) per reviewed video</li>
						)}
						{nonSelfReview?.rubricSubmission && <li>submitting a rubric</li>}

						{/* Provided Review preview */}
						{providedReview?.required && <li>reviewing the provided recording</li>}
						{!!providedReview?.commentsNumber && (
							<li>leaving at least {providedReview?.commentsNumber} comment(s)</li>
						)}
						{!!providedReview?.markersNumber && (
							<li>leaving at least {providedReview?.markersNumber} marker(s)</li>
						)}
						{providedReview?.rubricSubmission && <li>submitting a rubric</li>}
					</ul>
				</>
			)}
		</div>
	);
};

export default ScoreSettingsPreview;
